import {createModel} from "hox"

const SMART_SEARCH_FLAG_DIV = "sslfdiv"

function useUpdateLoadingStatus() {
    const toLoading = () => {
        const flagDiv = document.getElementById(SMART_SEARCH_FLAG_DIV)
        flagDiv?.setAttribute("status", "loading")
    }

    return {
        toLoading,
    }
}

export default createModel(useUpdateLoadingStatus)
